import { createContext, useContext } from "react";
import { useDicomDownload } from "./useDicomDownload";

const DicomDownloadContext = createContext(null);

export function DicomDownloadProvider({ children }) {
  const { downloadDicom, downloads, removeDownload } = useDicomDownload();

  return (
    <DicomDownloadContext.Provider
      value={{ downloadDicom, downloads, removeDownload }}
    >
      {children}
    </DicomDownloadContext.Provider>
  );
}

export function useDicomDownloadContext() {
  return useContext(DicomDownloadContext);
}
